import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h2 className="text-sm font-medium tracking-[0.2em] uppercase mb-2">
            Privacy Policy
          </h2>
          <p className="text-sm text-gray-600 font-normal tracking-wide">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="space-y-8">
          <section>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide mb-4">
              At ArtRewards, accessible from https://artrewards.net/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by ArtRewards and how we use it.
            </p>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide mb-4">
              If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
            </p>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in ArtRewards. This policy is not applicable to any information collected offline or via channels other than this website.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Consent
            </h3>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              By using our website, you hereby consent to our Privacy Policy and agree to its terms.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Information we collect
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
              </p>
              
              <p>
                If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
              </p>
              
              <p>
                When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              How we use your information
            </h3>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide mb-4">
              We use the information we collect in various ways, including to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 font-normal leading-relaxed tracking-wide ml-4">
              <li>Provide, operate, and maintain our website</li>
              <li>Improve, personalize, and expand our website</li>
              <li>Understand and analyze how you use our website</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
              <li>Send you emails</li>
              <li>Find and prevent fraud</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Log Files
            </h3>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              ArtRewards follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Google DoubleClick DART Cookie
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – https://policies.google.com/technologies/ads
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Advertising Partners Privacy Policies
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                You may consult this list to find the Privacy Policy for each of the advertising partners of ArtRewards.
              </p>
              
              <p>
                Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on ArtRewards, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
              </p>
              
              <p>
                Note that ArtRewards has no access to or control over these cookies that are used by third-party advertisers.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Third Party Privacy Policies
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                ArtRewards's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
              </p>
              
              <p>
                You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              CCPA Privacy Rights (Do Not Sell My Personal Information)
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                Under the CCPA, among other rights, California consumers have the right to:
              </p>
              
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</li>
                <li>Request that a business delete any personal data about the consumer that a business has collected.</li>
                <li>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</li>
              </ul>
              
              <p>
                If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
              </p>
            </div>
          </section>

=          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              GDPR Data Protection Rights
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
              </p>
              
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>The right to access</strong> – You have the right to request copies of your personal data. We may charge you a small fee for this service.</li>
                <li><strong>The right to rectification</strong> – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</li>
                <li><strong>The right to erasure</strong> – You have the right to request that we erase your personal data, under certain conditions.</li>
                <li><strong>The right to restrict processing</strong> – You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
                <li><strong>The right to object to processing</strong> – You have the right to object to our processing of your personal data, under certain conditions.</li>
                <li><strong>The right to data portability</strong> – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
              </ul>
              
              <p>
                If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Children's Information
            </h3>
            <div className="space-y-4 text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              <p>
                Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
              </p>
              
              <p>
                ArtRewards does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">
              Contact Us
            </h3>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="text-sm text-gray-700 font-normal leading-relaxed tracking-wide mt-2">
              By email: <span className="text-black">info@artrewards.net</span>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;